<template>
  <div>
    <mall-header ></mall-header>
    <div class="guide-content" ></div>
    <div class="statisticsDetails-header">
    <nav-Menu></nav-Menu>
    <div  class=" statisticsDetails-div" >
        <span class="statisticsDetails-div-span" >使用明细</span>
        <span class="statisticsDetails-div-span1"  @click="barckPerv">返回上一级</span>
        <span class="statisticsDetails-div-line"></span>
        <div style="    float: left;  width: 100%; "  >
            <el-date-picker
            class='statisticsDetails-div-date'
              v-model="dateMonthr"
              type="monthrange"
              range-separator="-"
             start-placeholder="开始日期"
             end-placeholder="结束日期"
              @change="Datechange"
              align='center'
              prefix-icon="el-icon-date"
               >
            </el-date-picker>
            <el-button @click="exportStatisticsDetails('使用统计明细')" class="statisticsDetails-div-button"  >导出</el-button>
            <el-table class="statisticsDetails-table"  @filter-change="filterChange" :row-style="{height:'45px'}" v-loading="statisticsLoading"   :cell-style="{'padding-top': '7px','padding-bottom': '7px'}" :header-cell-style="{height:'40px',background: '#F6F6F6',color:'#666','font-size': '14px','font-family': 'PingFang SC','font-weight': '500'}" :data="tableData" >
                <el-table-column prop="statDay"  label="使用时间" width="240"></el-table-column>
                <el-table-column  prop="serviceItemName" column-key="type" :filter-multiple="true"  label="服务项目" width="240" :filters="serviceNames"  filter-placement="bottom-end">
                    <template slot-scope="scope">
                       <el-tooltip placement="right"   :open-delay="500"  :disabled="nameTips" :content='scope.row.serviceItemName' >
                             <span  class="name-css"   @mouseenter="nameTipsFun($event)" >{{scope.row.serviceItemName}}</span>
                         </el-tooltip>
                    </template>
                </el-table-column >
                <el-table-column  prop="serviceItemUnit" width="100" label="单位" align="center">
                </el-table-column>
                <el-table-column  prop="amount" column-key="type" label="收入/支出" align="right" width="150"  :filters="array"
                      :filter-multiple="true" filter-placement="bottom-end">
                   <template slot-scope="scope">
                      <span v-if="scope.row.amount>0" style="color: #333333;">{{scope.row.amount}}</span>
                      <span v-if="scope.row.amount<0" style="color:#FF620D">{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remainAmount"  label="剩余数量" align="center" width="190"></el-table-column>
                 <template slot="empty" v-loading="statisticsLoading">
                      <div  style="   margin-top: 100px;">
                        <img src="../../static/images/空.png" alt="" >
                        <p  class="invoiceList-defut-font">哎呀，什么都没有 T_T</p>
                      </div>
                 </template>
            </el-table>
            <div v-if="tableData.length>0" id="orderAllPage">
                  <el-pagination background
                    style=" float: right;margin-right: 30px;    margin-bottom: 20px;"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="querydata.pageNo"
                      :page-sizes="[ 10, 20, 40]"
                      :page-size="querydata.pageSize"
                      layout="total, sizes, prev, pager, next"
                      :total="detailstotal">
                  </el-pagination>
            </div>
            <el-backtop  :bottom="100" style="right: auto;" >
              <div
                style="
                  height: 100%;
                  width: 100%;
                  box-shadow: 0 0 6px rgba(0,0,0, .12);
                  text-align: center;
                  line-height: 40px;
                  color: #1989fa; ">
                <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
              </div>
            </el-backtop>
        </div>
    </div>
    </div>
     <mall-footer ></mall-footer>
  </div>
</template>
<script>
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import navMenu from '../components/navMenu.vue'
import axios from 'axios'
import http from '../api/public'

  export default {
    data () {
      return {
        orderList:[],
        currentPage: 4,
        dateMonthr:"",
        tableData: [],
        serviceNames:[],
        array:[{ text: '收入', value: '收入' }, { text: '支出', value: '支出' }],
        mdShow:false,
        payShow:true,
        nameTips:true,
        selectType:0,
        detailsTotal:0,
        statisticsLoading:true,
        queryParams:{},//使用统计导出请求参数
        querydata:{
          pageNo:1,//初始显示第几页
          pageSize:10//每页显示多少数据
        },
      }
    },
    mounted() {
      //使用统计详情列表
      var newDate = new Date();
      let  end= this.formatDateTime(newDate)
      let start = this.formatDateTime(newDate,1)
      this.dateMonthr= [start,end]
      this.querydata.createTime_begin = start
      this.querydata.createTime_end = end
      this.getDetailsData();
    },
    methods: {
      //使用统计详情列表
      getDetailsData() {
        axios.get('/mallApi/mall/index/listTradeRecordStat',{params:this.querydata ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          res = res.data;
          //debugger
          if(res.success) {
            this.tableData = res.result.records;
            this.detailstotal = res.result.total;
            if(this.tableData.length){
                this.tableData.forEach(da => {
                  this.serviceNames.push({ "text": da.serviceItemName, "value": da.serviceItemId });
                });
            }
           console.log( this.serviceNames);
          }else{
            if(res.code == 401 || res.code == 400 ) {
                http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{
                this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
              }
          }
        this.statisticsLoading =false;
        });
      },
      //返回使用统计列表
     barckPerv(){
         this.$router.push({ path:'/statisticsList'  })
     },
      filterChange(filters) {
        debugger
        var tempArray = [];
        var typeArray =[];
        if(filters.type.length){
          filters.type.forEach(da => {
            if(da =="支出"){
              typeArray.push(2)
            }else if(da =="收入"){
              typeArray.push(1)
            }else {
              tempArray.push(da)
            }
          });
        }
         this.querydata.type =typeArray.join();
         this.querydata.serviceItemId =tempArray.join();
         this.getDetailsData();
      },
     //导出当前用户使用统计明细数据
     exportStatisticsDetails(filename){
        axios.get('/mallApi/mall/index/exportTradeRecordStat',{params:this.queryParams ,headers:{"token": localStorage.getItem("Authorization")},responseType: 'blob'}).then((res) => {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
            const downloadElement = document.createElement('a')  // 创建下载的链接
            const href = window.URL.createObjectURL(blob)
            downloadElement.href = href
            downloadElement.download = filename+'.xls'  // 下载后的文件名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 下载
            document.body.removeChild(downloadElement) // 下载完成 移除 a
            window.URL.revokeObjectURL(href) // 释放blob对象
      })
     },
      nameTipsFun(obj){
        var off = obj.target.offsetWidth;
       // let  sHeight = obj.currentTarget.scrollHeight;
        off > 186? this.nameTips = false : this.nameTips = true;
      },

     //时间转换
    formatDateTime (date ,a) {
        var y = date.getFullYear();
       var m ="";
        if(a){
            m = date.getMonth();
        }else{
            m = date.getMonth() + 1;
        }
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h=h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second=date.getSeconds();
        second=second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },
     //时间转换
    formatDateInit (date,a) {
        var y = date.getFullYear();
        var m ="";
        if(a){
            m = date.getMonth() + 2;
        }else{
            m = date.getMonth() + 1;
        }
        m = m < 10 ? ('0' + m) : m;
        var d = '01';
        //d = d < 10 ? ('0' + d) : d;
        var h = '00';
        //h=h < 10 ? ('0' + h) : h;
        var minute = '00';
        var second='00';
        //second=second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },

      filterTag(value, row) {
        return row.tag === value;
      },
    //时间控件change 事件
      Datechange() {
        //debugger
        let tempDate  = this.dateMonthr;
        if(tempDate){
          let start = this.formatDateInit(tempDate[0])
          let end = this.formatDateInit(tempDate[1])
          this.querydata.createTime_begin = start
          this.querydata.createTime_end = end
          this.queryParams.createTime_begin= start
           this.queryParams.createTime_end= end
        }else{
          this.querydata.createTime_begin = ""
          this.querydata.createTime_end = ""
           this.queryParams.createTime_begin= ""
           this.queryParams.createTime_end = ""
        }

          console.log(this.querydata);
         this.getDetailsData()

      },

      //分页当前页change 事件
      handleCurrentChange(currentPage){
        this.querydata.pageNo = currentPage;
        this.getDetailsData();
      },
      //分页当前条数 change 事件
      handleSizeChange(pagesize){
        this.querydata.pageSize = pagesize;
        this.getDetailsData();

      },

    },
    components: {
      mallHeader,
      mallFooter,
      mallBread,
      navMenu,
      http
    }
  }
</script>
<style lang="scss">
  @import "../assets/style/mixin";
.el-month-table td .cell {
    width: 60px;
    height: 36px;
    display: block;
    line-height: 36px;
    color: #606266;
    margin: 0 auto;
    border-radius: 4px !important;
}

 .statisticsDetails-div   div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}
.el-month-table td.end-date .cell, .el-month-table td.start-date .cell {
    color: #FFF;
    background-color: #287EFF !important;
}
.el-month-table td.start-date div {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
}
.el-month-table td.end-date div {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}
.el-month-table td div {
    height: 35px!important;
    padding: 0px 0px !important;
    box-sizing: border-box;
}
//  table, table tr th, table tr td {
//      border: 0px solid #EEEEEE ;
// }
.el-table__column-filter-trigger {
    display: inline-block;
    line-height: 25px;
    cursor: pointer;
}
.statisticsDetails-div div.el-table__empty-block {
    text-align: center;
    width: 100%;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    margin-bottom: 179px;
}
.statisticsDetails-header{
   overflow-x: auto;  min-width: 1200px;   width: 1200px;margin: 0 auto;
}
.statisticsDetails-div-p{
      margin-top: -120px;
    margin-left: 420px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 45px;
}
.el-range-editor.el-input__inner {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0px 10px;
}


  .gray-sub-title {
    height: 38px;
    padding: 0 24px;
    background: #FFFFFF;
    border-top: 1px solid #DBDBDB;
    border-bottom: 1px solid #DBDBDB;
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    display: flex;
    span {
      display: inline-block;
      height: 100%;
    }
    .first {
      display: flex;
      justify-content: space-between;
      flex: 1;
      .f-bc {
        > span {
          width: 112px;
          text-align: center;
        }
      }
    }
    .last {
      width: 230px;
      text-align: center;
      display: flex;
      border-left: 1px solid #ccc;
      span {
        flex: 1;
      }
    }
  }
.statisticsDetails-div-button:active {
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    color: #287EFF;
}
.statisticsDetails-div-button:focus {
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    color: #287EFF;
}

.statisticsDetails-div{
      width: 980px;
    min-width: 980px;
    margin-bottom: 60px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    overflow: auto;
    margin: 0 auto;
    float: left;
    margin-top: -360px;
    margin-left: 220px;
    min-height:480px;
}
.statisticsDetails-div-min{
       margin-left: 220px;
    width: 980px;
    height: 560px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    margin-top: -360px;
}
.statisticsDetails-div-span{
     height: 16px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    float: left;
    margin-left: 30px;
    margin-top: 20px;
}
.statisticsDetails-div-span1{
   float: right;
          margin-right: 30px;
          margin-top: 20px;
          height: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #287EFF;
          cursor: pointer;
          line-height: 20px;
}
.statisticsDetails-div-span1:hover{text-decoration: underline;border-bottom:2px; color:#287EFF }
// .name-css:hover{text-decoration: underline;border-bottom:2px; color:#287EFF }
.statisticsDetails-div-line{
     width: 980px;
    border-bottom: 1px solid #EEEEEE;
    height: 1px;
    position: absolute;
    margin-top: 60px;
    margin-left: -95px
}

.statisticsDetails-div-date{
    float: left;margin-left: 30px;
    margin-top: 45px;
    width: 240px!important;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 2px;
    height: 32px;
}
.el-date-editor .el-range-separator {
    padding: 0px 5px;
    line-height: 32px;
    width: 5%;
    color: rgb(48, 49, 51);
    margin-top: -10px !important;
}
.statisticsDetails-div-button{
    float: right;
    margin-right: 30px;
    margin-top: 45px;
    width: 82px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
    line-height: 8px;
}
.statisticsDetails-div-button:hover{
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    opacity: 0.6;
    color: #287EFF;
}
.statisticsDetails-div-button .el-button:active{
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    border-radius: 4px;
     transition: all 0s;
}
.statisticsDetails-table{
    width: 920px;
    height: auto;
    background: white;
    margin: 20px 30px 20px 30px;
    float: left;
    min-height: 275px;
}
  .bt {
    border-top: 1px solid #EFEFEF;
  }

  .date {
    padding-left: 0px;
  }

  .order-id {
    margin-left: 25px;
  }

  .cart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    &:hover {
      .del-order {
        display: block;
        background:#d1434a;
        padding:2px 6px;
        border-radius:6px;
        color:#fff;
        font-size:14px;
        margin-top:-3px;
      }
    }
    .del-order {
      display: none;
    }
    .cart-l {
      display: flex;
      align-items: center;
      flex: 1;
      padding: 15px 0;
      justify-content: space-between;
      position: relative;
      &:before {
        position: absolute;
        content: ' ';
        right: -1px;
        top: 0;
        width: 1px;
        background-color: #EFEFEF;
        height: 100%;
      }
      .ellipsis {
        margin-left: 20px;
        width: 220px;
      }
      .img-box {
        border: 1px solid #EBEBEB;
      }
      img {
        display: block;
        @include wh(80px);
      }
      .cart-l-r {
        display: flex;
        height:24px;
        line-height: 24px;
        > div {
          text-align: center;
          width: 112px;
        }
      }
      .car-l-l {
        display: flex;
        align-items: center;
      }
    }
    .cart-r {
      width: 230px;
      display: flex;
      span {
        text-align: center;
        flex: 1;
      }
    }
  }

  .prod-operation {
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 254px;
    .total{
      flex:0 0 100px;
      text-align: center;
      color:#d1434a;
    }
    .pay-content{
      flex:1;
      .payBtn {
        background:#20a0ff;
        padding:5px 10px;
        border-radius:6px;
        color:#fff;
        font-size:14px;
        margin: 0 auto;
      }
      .alreadyPay{
        font-size:14px;
        color:#999;
        text-align:center;
      }
    }
    div:last-child {
      padding-right: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// statisticsDetails.vue?b0489f16